import * as React from 'react';
import {Navigate, Route, Routes as RouterRoutes} from 'react-router-dom';
import {useAbility} from '~/lib/ability';
import {advancedDataLinks, TurniloAdvancedDataView} from '~/modules/AdvancedData';
import {appAdsLinks} from '~/modules/AppAds';
import {AppAdsRoute} from '~/modules/AppAds/routes';
import {pmpLinks, PmpRouter} from './modules/Pmp';
import {auditLinks, AuditView} from '~/modules/Audit';
import {biddersLinks, BiddersRoute} from '~/modules/Bidders';
import {businessIncentivesLinks, BusinessIncentivesRoute} from '~/modules/BusinessIncentives';
import {clientsLinks, ClientsRoute} from '~/modules/Clients';
import {SellersJsonView} from '~/modules/Clients/views/SellersJsonView';
import {SelfServeSellerView} from '~/modules/Clients/views/SelfServeSellerView';
import {creativesLinks, CreativesView} from '~/modules/Creatives';
import {TopCreativesPreview} from '~/modules/Creatives/views/TopCreativesPreview';
import {dashboardLinks, DashboardView} from '~/modules/Dashboard';
import {dictionaryLinks, DictionaryView} from '~/modules/Dictionary';
import {paymentsLinks} from '~/modules/Payments/links';
import {PaymentsView} from '~/modules/Payments/views/PaymentsView';
import {PaymentsTrolleyView} from '~/modules/Payments/views/PaymentsTrolleyView';
import {PaymentsTransactionHistoryView} from '~/modules/Payments/views/PaymentsTransactionHistoryView';
import {PrePaymentsView} from '~/modules/Payments/views/PrePaymentsView';
import {ApiTokensView, profileLinks, ProfileView} from '~/modules/Profile';
import {RecoveryView} from '~/modules/Profile/views/RecoveryView';
import {SignInView} from '~/modules/Profile/views/SignInView';
import {sourcesLinks, SourcesRoute} from '~/modules/Sources';
import {usersLinks, UsersRouter} from '~/modules/Users';
import {rillAnalyticsLinks, RillAnalyticsView} from '~/modules/RillAnalytics';
import {featuresLinks, FeaturesView} from '~/modules/Features';
import {RootAbility} from '~/root_ability';


export const GuestRoutes = () => (
    <RouterRoutes>
        <Route path="/sign-in" element={<SignInView/>}/>
        <Route path="/recovery/*" element={<RecoveryView/>}/>
        <Route path="*" element={<Navigate to="/sign-in" replace />}/>
    </RouterRoutes>
);

export const AppRoutes = () => {
    const ability = useAbility(RootAbility);

    return (
        <RouterRoutes>
            <Route path={`${dashboardLinks.dashboard()}/*`} element={<DashboardView/>}/>
            {ability.canViewBidders() && <Route path={`${biddersLinks.bidders()}/*`} element={<BiddersRoute/>}/>}
            {ability.canViewBusinessIncentives() &&
                <Route path={`${businessIncentivesLinks.businessIncentives()}/*`} element={<BusinessIncentivesRoute/>}/>}
            {ability.canViewSources() && <Route path={`${sourcesLinks.sources()}/*`} element={<SourcesRoute/>}/>}
            {ability.canViewSellersJson() &&
                <Route path={clientsLinks.sellersJson()} element={<SellersJsonView/>}/>}
            {(ability.canViewPayments() || ability.canViewPaymentsTrolley()) &&
                <Route path={paymentsLinks.payments()} element={<PaymentsView/>}/>}
            {ability.canViewPaymentsTrolley() &&
                <Route path={paymentsLinks.paymentsTrolley()} element={<PaymentsTrolleyView/>}/>}
            {ability.canViewPaymentsTransactionHistory() &&
                <Route path={paymentsLinks.transactionHistory()} element={<PaymentsTransactionHistoryView/>}/>}
            {ability.canViewPaymentsTransactionHistory() &&
                <Route path={paymentsLinks.prePayments()} element={<PrePaymentsView/>}/>}
            {ability.canViewAdvancedData() &&
                <Route path={advancedDataLinks.advancedData()} element={<TurniloAdvancedDataView/>}/>}
            {ability.canViewCreatives() && <Route path={creativesLinks.creatives()} element={<CreativesView/>}/>}
            {ability.canViewTopCreatives() && <Route path={creativesLinks.topPreview()} element={<TopCreativesPreview/>}/>}
            {ability.canViewAudit() && <Route path={auditLinks.audit()} element={<AuditView/>}/>}
            {ability.canViewClients() && <Route path={`${clientsLinks.clients()}/*`} element={<ClientsRoute/>}/>}
            {ability.canViewSellerSettings() &&
                <Route path={clientsLinks.selfServeSeller()} element={<SelfServeSellerView/>}/>}
            {ability.canViewUsers() && <Route path={`${usersLinks.users()}/*`} element={<UsersRouter/>}/>}
            <Route path={`${appAdsLinks.main()}/*`} element={<AppAdsRoute/>}/>
            {ability.isAdmin() && <Route path={`${pmpLinks.pmp()}/*`} element={<PmpRouter/>}/>}
            {ability.isAdmin() && <Route path={`${dictionaryLinks.dictionary()}/:category`} element={<DictionaryView/>}/>}
            {ability.isAdmin() && <Route path={dictionaryLinks.dictionary()} element={<DictionaryView/>}/>}
            {ability.canViewRillAnalytics() && <Route path={rillAnalyticsLinks.rillAnalytics()} element={<RillAnalyticsView/>}/>}
            <Route path={profileLinks.profile()} element={<ProfileView/>}/>
            {ability.canViewApiTokens() && <Route path={profileLinks.apiTokens()} element={<ApiTokensView/>}/>}
            {ability.canViewFeatures() && <Route path={featuresLinks.features()} element={<FeaturesView/>}/>}
            <Route path="*" element={<Navigate to={dashboardLinks.performanceByType()} replace />}/>
        </RouterRoutes>
    );
};
